import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { createRequestOption, IPaymentHistory } from '@appshared';

export type PaymentUploadResponseType = {
  page?: number,
  size?: number,
  totalElements?: number,
  contents?: IPaymentHistory[]
};

@Injectable()
export class PaymentDataApiService {
  protected resourceUrl = 'sale-data-svc/api/payments/upload-history';

  constructor(
    public _http: HttpClient,
  ) {}

  /**
   * API to get payment upload histories
   *
   * @param {*} [req]
   * @return {*}  {Observable<IPaymentHistory[]>}
   * @memberof PaymentHistoryApiService
   */
  query(req?: any): Observable<PaymentUploadResponseType> {
    const options = createRequestOption(req);
    return this._http.get<PaymentUploadResponseType>(this.resourceUrl, { params: options });
  }
}
